import { render, staticRenderFns } from "./EditFormPage.vue?vue&type=template&id=399889a3&scoped=true"
import script from "./EditFormPage.vue?vue&type=script&lang=ts"
export * from "./EditFormPage.vue?vue&type=script&lang=ts"
import style0 from "./EditFormPage.vue?vue&type=style&index=0&id=399889a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399889a3",
  null
  
)

export default component.exports